import {FC, memo, useCallback, useEffect, useMemo, useState} from "react";
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {Project} from "@brg/api";
import {PSLongread} from "../sections/ps-longread";
import {LayoutConst, useModal} from "../../../../core";
import {ModerationType} from "../../teams/const/ModerationTypes";
import {createPortal} from "react-dom";
import {CourseInfoList} from "./CourseInfoList/CourseInfoList";
import {useDispatch, useSelector} from "react-redux";
import {HseContextActions} from "shared/reducers/hseCurrentContext";
import {ROLES, useCoursesRole} from "shared/hooks/api/LMS/useCoursesRole";
import {CourseInfoLisActions, CourseInfoLisSelector, NULL_COUNT} from "shared/reducers/CourseInfoListSlice";
import {CourseInfoHeader} from "./CourseInfoList/components/CourseInfoHeader";
import styled from "styled-components";
import {selectorLMSModuleInfo} from "../../../reducers/LMSSlice";
import {useGetLMSDisciplines} from "../../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../../helpers/LMS/getDisciplineColorFromId";
import {useProfile} from "@brg/auth";
import InfiniteScroll from "react-infinite-scroll-component";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import {ProgressBar} from "../../../icons/Progress";
import {useGetManyByListPaginated} from "../../../hooks/api/LMS/useGetManyByListPaginated";

const CourseInfoWrapper = styled.div`
  position: fixed;
  left: 0px;
  top: 64px;
  z-index: 100;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    top: 52px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    top: 48px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    right: 0;
    left: auto;
  }
`

export const AnchorWrapper = styled.div`
  position: fixed;
  left: 0px;
  top: 64px;
  z-index: 100;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    top: 52px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    top: 48px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    right: 0;
    left: auto;
  }
`
const InfiniteScrollWrapepr = styled.div`
    .infinite-scroll-component{
        overflow: visible !important;
    }
`

const INFO_LIST = ['theme_structure'];
const ANCHOR_BLOCK_LIST = ['course_theme', 'course_homework'];
const HEADER_ANCHOR_BLOCK_LIST = ['course_theme', 'course_lesson'];
const THEMES_PER_PAGE = 1;

//@ts-ignore
const hasCourseRole = (sign: string, role: string) => ROLES[role] === sign

const LMSLongreadList: FC<{project: Project}> = ({ project }) => {

    const lmsModuleInfo = useSelector(selectorLMSModuleInfo);
    const modal = useModal();
    const dispatch = useDispatch();
    const isTablet = useIsMobile();
    const outer = document.getElementById('theme-nav-portal');
    const [showHomeWork, setShowHomeWork] = useState(true);
    const [currentPost, setCurrentPost] = useState(null);
    const [themeAnchors, setThemeAnchors] = useState({});
    const [headerThemeAnchors, setHeaderThemeAnchors] = useState({});
    const [visibleThemesCount, setVisibleThemesCount] = useState(THEMES_PER_PAGE);
    const [isHeaderVisible, setIsHeaderVisible] = useState(false);

    const handleHeaderVisibilityChange = useCallback((visible: boolean) => {
        setIsHeaderVisible(prev => {
            if (prev !== visible) {
                return visible;
            }
            return prev;
        });
    }, []);
    const infoListVisible = useSelector(CourseInfoLisSelector)?.courseInfoVisibile;
    const is992 = useBreakpoint(LayoutConst.screen.m);
    //@ts-ignore
    const [role] = useCoursesRole(project?.projectId, project.longreadId);

    const isOwner = hasCourseRole(ROLES.teacher, role);
    const isParticipant = hasCourseRole(ROLES.student, role);
    const isJury = hasCourseRole(ROLES.jury, role);
    const hasAccess = isOwner || isParticipant || isJury;

    const profile = useProfile();
    const profileId = profile?.accountId;
    const { t } = useTranslation();
    const theme = useTheme();

    useEffect(() => {
        dispatch(CourseInfoLisActions.setDiscipline(lmsModuleInfo?.disciplineId || ''))
    }, [lmsModuleInfo])

    // @ts-ignore
    const teams = project?.teams;

    const currentTeamId = useMemo(() => {
        if (!teams || teams?.length === 0) return '';

        return teams?.find((team: any) => team?.moderationType === ModerationType.LMS)?.teamId || ''
    }, [teams])
    const { colors: disciplineColors } = useGetLMSDisciplines(currentTeamId)

    const courseButtons = useMemo(() => {
        return lmsModuleInfo?.buttons || []
    }, [lmsModuleInfo])

    const isLastLongreadExam = useMemo(() => Boolean(lmsModuleInfo?.examInfo), [lmsModuleInfo])
    const longreadThemes = useMemo(() => ([...lmsModuleInfo?.themeInfos || [], ...(lmsModuleInfo?.examInfo ? [lmsModuleInfo?.examInfo] : [])]), [lmsModuleInfo])
    const hasLongreads = useMemo(() => (longreadThemes && !!longreadThemes?.length) , [longreadThemes])
    
    const allLMSLgIds = useMemo(() => {
        return longreadThemes?.map((theme: any) => theme?.longreadId).filter(Boolean) || [];
    }, [longreadThemes]);
    
    const { data: allLongreadPosts } = useGetManyByListPaginated({
        idsLongread: allLMSLgIds,
        limit: 0,
        offset: 0,
        page: 0,
        disabled: allLMSLgIds.length === 0,
        styles: ['course_theme', 'course_homework']
    });

        useEffect(() => {
            if (!allLongreadPosts?.length || !allLMSLgIds?.length) {
                return;
            }

            const postsByLongread: Record<string, any[]> = {};
            
            allLongreadPosts.forEach((post: any) => {
                const longreadId = post.longreadId;
                if (!postsByLongread[longreadId]) {
                    postsByLongread[longreadId] = [];
                }
                
                let postName = post.text || post.name || '';
                if (post.style === 'course_homework') {
                    postName = 'Домашняя работа';
                }
                
                postsByLongread[longreadId].push({
                    ...post,
                    name: postName
                });
            });

            const orderedThemeAnchors: Record<string, any[]> = {};
            const orderedHeaderAnchors: Record<string, any[]> = {};
            
            allLMSLgIds.forEach((longreadId) => {
                if (postsByLongread[longreadId]) {
                    if (isOwner) {
                        orderedThemeAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                        orderedHeaderAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            HEADER_ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                    } else {
                        const filteredAnchors = postsByLongread[longreadId].filter((block: any) => 
                            ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                        const anchorsWithoutHomework = filteredAnchors.filter((block: any) => 
                            block?.style !== 'course_homework'
                        );
                        const theme = longreadThemes?.find((t: any) => t?.longreadId === longreadId);

                        if (theme && 'needHomeWork' in theme && theme?.needHomeWork) {
                            const homeworkBlocks = postsByLongread[longreadId].filter((block: any) =>
                                block?.style === 'homework_student' ||
                                (block?.additionalInfo?.find((info: any) => info?.name === 'student_id') &&
                                 block?.additionalInfo?.find((info: any) => info?.name === 'student_id')?.value === profileId)
                            );
                            
                            if (homeworkBlocks.length > 0) {
                                const homeworkBlock = filteredAnchors.find((block: any) => 
                                    block?.style === 'course_homework'
                                );
                                if (homeworkBlock) {
                                    anchorsWithoutHomework.push(homeworkBlock);
                                }
                            }
                        }
                        
                        orderedThemeAnchors[longreadId] = anchorsWithoutHomework;
                        orderedHeaderAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            HEADER_ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                    }
                }
            });
            
            setThemeAnchors(orderedThemeAnchors);
            setHeaderThemeAnchors(orderedHeaderAnchors);
        }, [allLongreadPosts, allLMSLgIds, isOwner, profileId, longreadThemes]);
    // Разделяем темы и экзамен
    const themesWithoutExam = useMemo(() => {
        if (!longreadThemes) return [];
        return isLastLongreadExam 
            ? longreadThemes.slice(0, -1) 
            : longreadThemes;
    }, [longreadThemes, isLastLongreadExam]);
    
    const examTheme = useMemo(() => {
        if (!isLastLongreadExam || !longreadThemes?.length) return null;
        return longreadThemes[longreadThemes.length - 1];
    }, [longreadThemes, isLastLongreadExam]);
    
    // Фильтруем темы с longreadId
    const filteredThemesWithoutExam = useMemo(() => {
        return themesWithoutExam?.filter((i: any) => i?.longreadId) || [];
    }, [themesWithoutExam]);
    
    const visibleThemes = useMemo(() => {
        return filteredThemesWithoutExam.slice(0, visibleThemesCount);
    }, [filteredThemesWithoutExam, visibleThemesCount]);
    
    const hasMoreThemes = useMemo(() => {
        const hasMoreRegularThemes = visibleThemesCount < filteredThemesWithoutExam.length;
        const shouldLoadExam = visibleThemesCount >= filteredThemesWithoutExam.length && examTheme && !visibleThemes.some((t: any) => t.longreadId === examTheme.longreadId);
        return hasMoreRegularThemes || shouldLoadExam;
    }, [visibleThemesCount, filteredThemesWithoutExam.length, examTheme, visibleThemes]);
    
    // Сбрасываем счетчик при изменении списка тем
    useEffect(() => {
        setVisibleThemesCount(THEMES_PER_PAGE);
    }, [filteredThemesWithoutExam.length]);

    const shouldVisibleInfoList = useMemo(() => ((isTablet && infoListVisible) || !isTablet) , [isTablet, infoListVisible]);

    const onSortHomeWorkClick = useCallback((id: string) => {
        setShowHomeWork(!showHomeWork)
    },[showHomeWork])

    const onApplyExam = useCallback((id: string) => {
        modal.show(
            'send-project'
            , {
                id,
                isExam: true,
                isPreRegistration: false,
                onClose: () => modal.hide(),
            })
    },[])

    // @ts-ignore
    const onSetCurrentActivePost = useCallback((id) => {
        setCurrentPost(id)
    }, [])

    const currentAnchors = useSelector((state: any) => state?.hseContext?.anchorLinks) || [];

    useEffect(() => {
        // Проверяем, что у нас есть валидные данные
        if (!currentAnchors || !Array.isArray(currentAnchors)) {
            return;
        }

        let newAnchors: any[] = [];
        if (Object.values(themeAnchors)?.length) {
            Object.entries(Object.values(themeAnchors))?.map(([k, v]) => {
                //@ts-ignore
                newAnchors = [...newAnchors, ...v]
            })
        }
        let newHeaderAnchors: any[] = [];
        if (Object.values(headerThemeAnchors)?.length) {
            Object.entries(Object.values(headerThemeAnchors))?.map(([k, v]) => {
                //@ts-ignore
                newHeaderAnchors = [...newHeaderAnchors, ...v]
            })
        }
        
        const existingPostIds = new Set(currentAnchors.map((anchor: any) => anchor.postId));
        const onlyNewAnchors = [...newAnchors, ...newHeaderAnchors].filter((anchor: any) => 
            !existingPostIds.has(anchor.postId)
        );
        
        if (onlyNewAnchors.length > 0) {
            dispatch(HseContextActions.setAnchorLinks({ 
                anchors: [...currentAnchors, ...onlyNewAnchors], 
                limit: 0 
            }));
        }
    } , [themeAnchors, headerThemeAnchors, dispatch, currentAnchors])

    useEffect(() => {
        if (lmsModuleInfo && isTablet) {
            dispatch(
                CourseInfoLisActions.setItemCount(
                    longreadThemes?.length || NULL_COUNT
                )
            )
        }

        return () => {
            dispatch(CourseInfoLisActions.setItemCount(NULL_COUNT))
        }
    } , [lmsModuleInfo, longreadThemes, dispatch, isTablet])

    const loadMoreThemes = useCallback(() => {
        setVisibleThemesCount(prev => {
            const nextCount = prev + THEMES_PER_PAGE;
            const totalWithExam = filteredThemesWithoutExam.length + (examTheme ? 1 : 0);
            return Math.min(nextCount, totalWithExam);
        });
    }, [filteredThemesWithoutExam.length, examTheme]);
    
    const fullLmsLongreadOrder = useMemo(() => {
        const allThemes = [...filteredThemesWithoutExam];
        if (examTheme?.longreadId) {
            allThemes.push(examTheme);
        }
        return allThemes.map(longread => longread?.longreadId || '');
    }, [filteredThemesWithoutExam, examTheme]);

    const ThemesBlock = useMemo(() => {
        if (!hasLongreads) return null;

        const themesToRender = [...visibleThemes];
        
        const shouldShowExam = examTheme && visibleThemesCount > filteredThemesWithoutExam.length;
        if (shouldShowExam) {
            themesToRender.push(examTheme);
        }

        if (themesToRender.length === 0) return null;

        return themesToRender.map((i, index) => {
            const isExam = i?.longreadId === examTheme?.longreadId;
            const isLastVisibleTheme = index === themesToRender.length - 1 && !hasMoreThemes;
            
            return (
                <FlexBox 
                    key={i?.longreadId}
                    offsetTop={(index === 0 && is992) ? -8 : 0} 
                    offsetBottom={isLastVisibleTheme ? (is992 ? 24 : 32) : (is992 ? -8 : 0)}
                >
                    <PSLongread 
                        lastLongreadBlockLink={isLastVisibleTheme ? lmsModuleInfo?.nextModuleLink : undefined}
                        project={project}
                        customLGId={i?.longreadId}
                        onViewCurrentSlideScroll={onSetCurrentActivePost}
                        courseGeneralColor={getDisciplineColorFromId(lmsModuleInfo?.disciplineId || '', disciplineColors)}
                        teamId={currentTeamId}
                        onApplyExam={onApplyExam}
                        isThemeLongread
                        themeIndex={isExam ? -1 : index}
                        lmsLongreadOrder={fullLmsLongreadOrder}
                        onCheckHomework={() => window.open('/check-homework/' + project?.projectId + '?themeId=' + i?.longreadId)}
                        courseButtons={courseButtons}
                        lmsModuleInfo={lmsModuleInfo}
                    />
                </FlexBox>
            );
        });
    }, [
        hasLongreads, 
        visibleThemes,
        visibleThemesCount,
        filteredThemesWithoutExam.length,
        examTheme,
        hasMoreThemes, 
        is992, 
        lmsModuleInfo, 
        project, 
        onSetCurrentActivePost, 
        disciplineColors, 
        currentTeamId, 
        onApplyExam, 
        fullLmsLongreadOrder, 
        courseButtons
    ]);

    const canVisibleHomeWorkFilter = useMemo(() => (isOwner || isParticipant), [isOwner, isParticipant])

    const separateInfos = useMemo(() => {
        const result: any = [];

        if (hasLongreads) {
            visibleThemes.forEach((i: any) => {
                result.push(i);
                if (i?.needHomeWork && canVisibleHomeWorkFilter) {
                    //@ts-ignore
                    result.push({...i, isHomework: true });
                }
            });
            if (examTheme) {
                result.push({...examTheme, isExam: true });
            }
        }

        return result;
    }, [hasLongreads, visibleThemes, examTheme, canVisibleHomeWorkFilter])
    
    const separatedInfos = useMemo(() => {
        const result: any = [];

        if (hasLongreads) {
            longreadThemes.forEach((i: any, index: number) => {

                if (isLastLongreadExam && longreadThemes?.length - 1 === index) {
                    result.push({...i, isExam: true })
                    return;
                }

                result.push(i)
    
                if (i?.needHomeWork && canVisibleHomeWorkFilter) {
                    //@ts-ignore
                    result.push({...i, isHomework: true })
                }
            })
        }

        return result
    }, [lmsModuleInfo, showHomeWork, canVisibleHomeWorkFilter, hasLongreads, longreadThemes, isLastLongreadExam])

    //@ts-ignore
    const filteredInfos = useMemo(() => (separatedInfos.filter((i) => showHomeWork ? i : !!i.isHomework)) , [showHomeWork, separateInfos])

    const infoList = useMemo(() => {
        //@ts-ignore
        return INFO_LIST?.reduce((a,v) => { return [...a, {title: v, data: filteredInfos }]}, [])
    } , [filteredInfos, INFO_LIST]);

    const InfoList = useMemo(() => {
        if (outer) {
            return (
                createPortal(
                    <>
                    <CourseInfoWrapper>
                        <CourseInfoHeader 
                            headerThemeAnchors={headerThemeAnchors}
                            themesCount={lmsModuleInfo?.themeInfos?.length || 0}
                            hasExam={isLastLongreadExam}
                            onVisibilityChange={handleHeaderVisibilityChange}
                        />
                        </CourseInfoWrapper>
                    <AnchorWrapper>
                        {shouldVisibleInfoList && <CourseInfoList
                                //@ts-ignore
                                info={infoList}
                                anchors={themeAnchors}
                                onHmVisible={showHomeWork}
                                visibleFilter={canVisibleHomeWorkFilter}
                                onSortClick={onSortHomeWorkClick}
                                currentPost={currentPost}
                                hasHeader={isHeaderVisible}
                            />}
                        </AnchorWrapper>
                        </>
                , outer)
            )
        }
    }, [
        outer, 
        infoList, 
        themeAnchors, 
        showHomeWork, 
        currentPost, 
        canVisibleHomeWorkFilter, 
        onSortHomeWorkClick, 
        shouldVisibleInfoList,
        headerThemeAnchors,
        isLastLongreadExam,
        lmsModuleInfo,
        isHeaderVisible,
        handleHeaderVisibilityChange
    ])

    // Обработчик клика по теме в навигации - подгружаем темы до выбранной
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace('#', '');
            
            if (!hash || !allLongreadPosts?.length) {
                return;
            }

            // Находим postId в allLongreadPosts
            const post = allLongreadPosts.find((p: any) => p.postId === hash);
            
            if (post) {
                // Находим индекс темы по longreadId (включая экзамен)
                const allThemesWithExam = [...filteredThemesWithoutExam];
                if (examTheme) {
                    allThemesWithExam.push(examTheme);
                }
                
                const themeIndex = allThemesWithExam.findIndex((t: any) => t.longreadId === post.longreadId);
                
                if (themeIndex !== -1) {
                    // Загружаем все темы до выбранной включительно
                    const requiredCount = themeIndex + 1;
                    
                    if (requiredCount > visibleThemesCount) {
                        setVisibleThemesCount(requiredCount);
                    }
                }
            }
        };

        // Проверяем hash при монтировании и изменении
        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);
        
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [allLongreadPosts, filteredThemesWithoutExam, examTheme, visibleThemesCount]);

    if (!outer || !hasAccess) return null;

    return (
        <>
        <InfiniteScrollWrapepr>
            <InfiniteScroll
                dataLength={visibleThemes.length + (visibleThemesCount > filteredThemesWithoutExam.length && examTheme ? 1 : 0)}
                next={loadMoreThemes}
                hasMore={hasMoreThemes ?? false}
                loader={
                    <FlexBox justify="center" align="center" width="100%" offsetTop={24} offsetBottom={24}>
                        <ProgressBar
                            text={t('text.loading')}
                            loading={false}
                            color={theme.progressbar?.color}
                        />
                    </FlexBox>
                }
                scrollThreshold={0.8}
            >
                {ThemesBlock}
            </InfiniteScroll>
        </InfiniteScrollWrapepr>
            {InfoList}
        </>
    )
}

export default memo(LMSLongreadList);import {FC, memo, useCallback, useEffect, useMemo, useState} from "react";
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {Project} from "@brg/api";
import {PSLongread} from "../sections/ps-longread";
import {LayoutConst, useModal} from "../../../../core";
import {ModerationType} from "../../teams/const/ModerationTypes";
import {createPortal} from "react-dom";
import {CourseInfoList} from "./CourseInfoList/CourseInfoList";
import {useDispatch, useSelector} from "react-redux";
import {HseContextActions} from "shared/reducers/hseCurrentContext";
import {ROLES, useCoursesRole} from "shared/hooks/api/LMS/useCoursesRole";
import {CourseInfoLisActions, CourseInfoLisSelector, NULL_COUNT} from "shared/reducers/CourseInfoListSlice";
import {CourseInfoHeader} from "./CourseInfoList/components/CourseInfoHeader";
import styled from "styled-components";
import {selectorLMSModuleInfo} from "../../../reducers/LMSSlice";
import {useGetLMSDisciplines} from "../../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../../helpers/LMS/getDisciplineColorFromId";
import {useProfile} from "@brg/auth";
import InfiniteScroll from "react-infinite-scroll-component";
import {useTranslation} from "react-i18next";
import {useTheme} from "styled-components";
import {ProgressBar} from "../../../icons/Progress";
import {useGetManyByListPaginated} from "../../../hooks/api/LMS/useGetManyByListPaginated";

const CourseInfoWrapper = styled.div`
  position: fixed;
  left: 0px;
  top: 64px;
  z-index: 100;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    top: 52px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    top: 48px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    right: 0;
    left: auto;
  }
`

export const AnchorWrapper = styled.div`
  position: fixed;
  left: 0px;
  top: 64px;
  z-index: 100;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    top: 52px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    top: 48px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    right: 0;
    left: auto;
  }
`
const InfiniteScrollWrapepr = styled.div`
    .infinite-scroll-component{
        overflow: visible !important;
    }
`

const INFO_LIST = ['theme_structure'];
const ANCHOR_BLOCK_LIST = ['course_theme', 'course_homework'];
const HEADER_ANCHOR_BLOCK_LIST = ['course_theme', 'course_lesson'];
const THEMES_PER_PAGE = 1;

//@ts-ignore
const hasCourseRole = (sign: string, role: string) => ROLES[role] === sign

const LMSLongreadList: FC<{project: Project}> = ({ project }) => {

    const lmsModuleInfo = useSelector(selectorLMSModuleInfo);
    const modal = useModal();
    const dispatch = useDispatch();
    const isTablet = useIsMobile();
    const outer = document.getElementById('theme-nav-portal');
    const [showHomeWork, setShowHomeWork] = useState(true);
    const [currentPost, setCurrentPost] = useState(null);
    const [themeAnchors, setThemeAnchors] = useState({});
    const [headerThemeAnchors, setHeaderThemeAnchors] = useState({});
    const [visibleThemesCount, setVisibleThemesCount] = useState(THEMES_PER_PAGE);
    const [isHeaderVisible, setIsHeaderVisible] = useState(false);

    const handleHeaderVisibilityChange = useCallback((visible: boolean) => {
        setIsHeaderVisible(prev => {
            if (prev !== visible) {
                return visible;
            }
            return prev;
        });
    }, []);
    const infoListVisible = useSelector(CourseInfoLisSelector)?.courseInfoVisibile;
    const is992 = useBreakpoint(LayoutConst.screen.m);
    //@ts-ignore
    const [role] = useCoursesRole(project?.projectId, project.longreadId);

    const isOwner = hasCourseRole(ROLES.teacher, role);
    const isParticipant = hasCourseRole(ROLES.student, role);
    const isJury = hasCourseRole(ROLES.jury, role);
    const hasAccess = isOwner || isParticipant || isJury;

    const profile = useProfile();
    const profileId = profile?.accountId;
    const { t } = useTranslation();
    const theme = useTheme();

    useEffect(() => {
        dispatch(CourseInfoLisActions.setDiscipline(lmsModuleInfo?.disciplineId || ''))
    }, [lmsModuleInfo])

    // @ts-ignore
    const teams = project?.teams;

    const currentTeamId = useMemo(() => {
        if (!teams || teams?.length === 0) return '';

        return teams?.find((team: any) => team?.moderationType === ModerationType.LMS)?.teamId || ''
    }, [teams])
    const { colors: disciplineColors } = useGetLMSDisciplines(currentTeamId)

    const courseButtons = useMemo(() => {
        return lmsModuleInfo?.buttons || []
    }, [lmsModuleInfo])

    const isLastLongreadExam = useMemo(() => Boolean(lmsModuleInfo?.examInfo), [lmsModuleInfo])
    const longreadThemes = useMemo(() => ([...lmsModuleInfo?.themeInfos || [], ...(lmsModuleInfo?.examInfo ? [lmsModuleInfo?.examInfo] : [])]), [lmsModuleInfo])
    const hasLongreads = useMemo(() => (longreadThemes && !!longreadThemes?.length) , [longreadThemes])
    
    const allLMSLgIds = useMemo(() => {
        return longreadThemes?.map((theme: any) => theme?.longreadId).filter(Boolean) || [];
    }, [longreadThemes]);
    
    const { data: allLongreadPosts } = useGetManyByListPaginated({
        idsLongread: allLMSLgIds,
        limit: 0,
        offset: 0,
        page: 0,
        disabled: allLMSLgIds.length === 0,
        styles: ['course_theme', 'course_homework']
    });

        useEffect(() => {
            if (!allLongreadPosts?.length || !allLMSLgIds?.length) {
                return;
            }

            const postsByLongread: Record<string, any[]> = {};
            
            allLongreadPosts.forEach((post: any) => {
                const longreadId = post.longreadId;
                if (!postsByLongread[longreadId]) {
                    postsByLongread[longreadId] = [];
                }
                
                let postName = post.text || post.name || '';
                if (post.style === 'course_homework') {
                    postName = 'Домашняя работа';
                }
                
                postsByLongread[longreadId].push({
                    ...post,
                    name: postName
                });
            });

            const orderedThemeAnchors: Record<string, any[]> = {};
            const orderedHeaderAnchors: Record<string, any[]> = {};
            
            allLMSLgIds.forEach((longreadId) => {
                if (postsByLongread[longreadId]) {
                    if (isOwner) {
                        orderedThemeAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                        orderedHeaderAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            HEADER_ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                    } else {
                        const filteredAnchors = postsByLongread[longreadId].filter((block: any) => 
                            ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                        const anchorsWithoutHomework = filteredAnchors.filter((block: any) => 
                            block?.style !== 'course_homework'
                        );
                        const theme = longreadThemes?.find((t: any) => t?.longreadId === longreadId);

                        if (theme && 'needHomeWork' in theme && theme?.needHomeWork) {
                            const homeworkBlocks = postsByLongread[longreadId].filter((block: any) =>
                                block?.style === 'homework_student' ||
                                (block?.additionalInfo?.find((info: any) => info?.name === 'student_id') &&
                                 block?.additionalInfo?.find((info: any) => info?.name === 'student_id')?.value === profileId)
                            );
                            
                            if (homeworkBlocks.length > 0) {
                                const homeworkBlock = filteredAnchors.find((block: any) => 
                                    block?.style === 'course_homework'
                                );
                                if (homeworkBlock) {
                                    anchorsWithoutHomework.push(homeworkBlock);
                                }
                            }
                        }
                        
                        orderedThemeAnchors[longreadId] = anchorsWithoutHomework;
                        orderedHeaderAnchors[longreadId] = postsByLongread[longreadId].filter((block: any) => 
                            HEADER_ANCHOR_BLOCK_LIST.includes(block?.style || '')
                        );
                    }
                }
            });
            
            setThemeAnchors(orderedThemeAnchors);
            setHeaderThemeAnchors(orderedHeaderAnchors);
        }, [allLongreadPosts, allLMSLgIds, isOwner, profileId, longreadThemes]);
    // Разделяем темы и экзамен
    const themesWithoutExam = useMemo(() => {
        if (!longreadThemes) return [];
        return isLastLongreadExam 
            ? longreadThemes.slice(0, -1) 
            : longreadThemes;
    }, [longreadThemes, isLastLongreadExam]);
    
    const examTheme = useMemo(() => {
        if (!isLastLongreadExam || !longreadThemes?.length) return null;
        return longreadThemes[longreadThemes.length - 1];
    }, [longreadThemes, isLastLongreadExam]);
    
    // Фильтруем темы с longreadId
    const filteredThemesWithoutExam = useMemo(() => {
        return themesWithoutExam?.filter((i: any) => i?.longreadId) || [];
    }, [themesWithoutExam]);
    
    const visibleThemes = useMemo(() => {
        return filteredThemesWithoutExam.slice(0, visibleThemesCount);
    }, [filteredThemesWithoutExam, visibleThemesCount]);
    
    const hasMoreThemes = useMemo(() => {
        const hasMoreRegularThemes = visibleThemesCount < filteredThemesWithoutExam.length;
        const shouldLoadExam = visibleThemesCount >= filteredThemesWithoutExam.length && examTheme && !visibleThemes.some((t: any) => t.longreadId === examTheme.longreadId);
        return hasMoreRegularThemes || shouldLoadExam;
    }, [visibleThemesCount, filteredThemesWithoutExam.length, examTheme, visibleThemes]);
    
    // Сбрасываем счетчик при изменении списка тем
    useEffect(() => {
        setVisibleThemesCount(THEMES_PER_PAGE);
    }, [filteredThemesWithoutExam.length]);

    const shouldVisibleInfoList = useMemo(() => ((isTablet && infoListVisible) || !isTablet) , [isTablet, infoListVisible]);

    const onSortHomeWorkClick = useCallback((id: string) => {
        setShowHomeWork(!showHomeWork)
    },[showHomeWork])

    const onApplyExam = useCallback((id: string) => {
        modal.show(
            'send-project'
            , {
                id,
                isExam: true,
                isPreRegistration: false,
                onClose: () => modal.hide(),
            })
    },[])

    // @ts-ignore
    const onSetCurrentActivePost = useCallback((id) => {
        setCurrentPost(id)
    }, [])

    const currentAnchors = useSelector((state: any) => state?.hseContext?.anchorLinks) || [];

    useEffect(() => {
        // Проверяем, что у нас есть валидные данные
        if (!currentAnchors || !Array.isArray(currentAnchors)) {
            return;
        }

        let newAnchors: any[] = [];
        if (Object.values(themeAnchors)?.length) {
            Object.entries(Object.values(themeAnchors))?.map(([k, v]) => {
                //@ts-ignore
                newAnchors = [...newAnchors, ...v]
            })
        }
        let newHeaderAnchors: any[] = [];
        if (Object.values(headerThemeAnchors)?.length) {
            Object.entries(Object.values(headerThemeAnchors))?.map(([k, v]) => {
                //@ts-ignore
                newHeaderAnchors = [...newHeaderAnchors, ...v]
            })
        }
        
        const existingPostIds = new Set(currentAnchors.map((anchor: any) => anchor.postId));
        const onlyNewAnchors = [...newAnchors, ...newHeaderAnchors].filter((anchor: any) => 
            !existingPostIds.has(anchor.postId)
        );
        
        if (onlyNewAnchors.length > 0) {
            dispatch(HseContextActions.setAnchorLinks({ 
                anchors: [...currentAnchors, ...onlyNewAnchors], 
                limit: 0 
            }));
        }
    } , [themeAnchors, headerThemeAnchors, dispatch, currentAnchors])

    useEffect(() => {
        if (lmsModuleInfo && isTablet) {
            dispatch(
                CourseInfoLisActions.setItemCount(
                    longreadThemes?.length || NULL_COUNT
                )
            )
        }

        return () => {
            dispatch(CourseInfoLisActions.setItemCount(NULL_COUNT))
        }
    } , [lmsModuleInfo, longreadThemes, dispatch, isTablet])

    const loadMoreThemes = useCallback(() => {
        setVisibleThemesCount(prev => {
            const nextCount = prev + THEMES_PER_PAGE;
            const totalWithExam = filteredThemesWithoutExam.length + (examTheme ? 1 : 0);
            return Math.min(nextCount, totalWithExam);
        });
    }, [filteredThemesWithoutExam.length, examTheme]);
    
    const fullLmsLongreadOrder = useMemo(() => {
        const allThemes = [...filteredThemesWithoutExam];
        if (examTheme?.longreadId) {
            allThemes.push(examTheme);
        }
        return allThemes.map(longread => longread?.longreadId || '');
    }, [filteredThemesWithoutExam, examTheme]);

    const ThemesBlock = useMemo(() => {
        if (!hasLongreads) return null;

        const themesToRender = [...visibleThemes];
        
        const shouldShowExam = examTheme && visibleThemesCount > filteredThemesWithoutExam.length;
        if (shouldShowExam) {
            themesToRender.push(examTheme);
        }

        if (themesToRender.length === 0) return null;

        return themesToRender.map((i, index) => {
            const isExam = i?.longreadId === examTheme?.longreadId;
            const isLastVisibleTheme = index === themesToRender.length - 1 && !hasMoreThemes;
            
            return (
                <FlexBox 
                    key={i?.longreadId}
                    offsetTop={(index === 0 && is992) ? -8 : 0} 
                    offsetBottom={isLastVisibleTheme ? (is992 ? 24 : 32) : (is992 ? -8 : 0)}
                >
                    <PSLongread 
                        lastLongreadBlockLink={isLastVisibleTheme ? lmsModuleInfo?.nextModuleLink : undefined}
                        project={project}
                        customLGId={i?.longreadId}
                        onViewCurrentSlideScroll={onSetCurrentActivePost}
                        courseGeneralColor={getDisciplineColorFromId(lmsModuleInfo?.disciplineId || '', disciplineColors)}
                        teamId={currentTeamId}
                        onApplyExam={onApplyExam}
                        isThemeLongread
                        themeIndex={isExam ? -1 : index}
                        lmsLongreadOrder={fullLmsLongreadOrder}
                        onCheckHomework={() => window.open('/check-homework/' + project?.projectId + '?themeId=' + i?.longreadId)}
                        courseButtons={courseButtons}
                        lmsModuleInfo={lmsModuleInfo}
                    />
                </FlexBox>
            );
        });
    }, [
        hasLongreads, 
        visibleThemes,
        visibleThemesCount,
        filteredThemesWithoutExam.length,
        examTheme,
        hasMoreThemes, 
        is992, 
        lmsModuleInfo, 
        project, 
        onSetCurrentActivePost, 
        disciplineColors, 
        currentTeamId, 
        onApplyExam, 
        fullLmsLongreadOrder, 
        courseButtons
    ]);

    const canVisibleHomeWorkFilter = useMemo(() => (isOwner || isParticipant), [isOwner, isParticipant])

    const separateInfos = useMemo(() => {
        const result: any = [];

        if (hasLongreads) {
            visibleThemes.forEach((i: any) => {
                result.push(i);
                if (i?.needHomeWork && canVisibleHomeWorkFilter) {
                    //@ts-ignore
                    result.push({...i, isHomework: true });
                }
            });
            if (examTheme) {
                result.push({...examTheme, isExam: true });
            }
        }

        return result;
    }, [hasLongreads, visibleThemes, examTheme, canVisibleHomeWorkFilter])
    
    const separatedInfos = useMemo(() => {
        const result: any = [];

        if (hasLongreads) {
            longreadThemes.forEach((i: any, index: number) => {

                if (isLastLongreadExam && longreadThemes?.length - 1 === index) {
                    result.push({...i, isExam: true })
                    return;
                }

                result.push(i)
    
                if (i?.needHomeWork && canVisibleHomeWorkFilter) {
                    //@ts-ignore
                    result.push({...i, isHomework: true })
                }
            })
        }

        return result
    }, [lmsModuleInfo, showHomeWork, canVisibleHomeWorkFilter, hasLongreads, longreadThemes, isLastLongreadExam])

    //@ts-ignore
    const filteredInfos = useMemo(() => (separatedInfos.filter((i) => showHomeWork ? i : !!i.isHomework)) , [showHomeWork, separateInfos])

    const infoList = useMemo(() => {
        //@ts-ignore
        return INFO_LIST?.reduce((a,v) => { return [...a, {title: v, data: filteredInfos }]}, [])
    } , [filteredInfos, INFO_LIST]);

    const InfoList = useMemo(() => {
        if (outer) {
            return (
                createPortal(
                    <>
                    <CourseInfoWrapper>
                        <CourseInfoHeader 
                            headerThemeAnchors={headerThemeAnchors}
                            themesCount={lmsModuleInfo?.themeInfos?.length || 0}
                            hasExam={isLastLongreadExam}
                            onVisibilityChange={handleHeaderVisibilityChange}
                        />
                        </CourseInfoWrapper>
                    <AnchorWrapper>
                        {shouldVisibleInfoList && <CourseInfoList
                                //@ts-ignore
                                info={infoList}
                                anchors={themeAnchors}
                                onHmVisible={showHomeWork}
                                visibleFilter={canVisibleHomeWorkFilter}
                                onSortClick={onSortHomeWorkClick}
                                currentPost={currentPost}
                                hasHeader={isHeaderVisible}
                            />}
                        </AnchorWrapper>
                        </>
                , outer)
            )
        }
    }, [
        outer, 
        infoList, 
        themeAnchors, 
        showHomeWork, 
        currentPost, 
        canVisibleHomeWorkFilter, 
        onSortHomeWorkClick, 
        shouldVisibleInfoList,
        headerThemeAnchors,
        isLastLongreadExam,
        lmsModuleInfo,
        isHeaderVisible,
        handleHeaderVisibilityChange
    ])

    // Обработчик клика по теме в навигации - подгружаем темы до выбранной
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace('#', '');
            
            if (!hash || !allLongreadPosts?.length) {
                return;
            }

            // Находим postId в allLongreadPosts
            const post = allLongreadPosts.find((p: any) => p.postId === hash);
            
            if (post) {
                // Находим индекс темы по longreadId (включая экзамен)
                const allThemesWithExam = [...filteredThemesWithoutExam];
                if (examTheme) {
                    allThemesWithExam.push(examTheme);
                }
                
                const themeIndex = allThemesWithExam.findIndex((t: any) => t.longreadId === post.longreadId);
                
                if (themeIndex !== -1) {
                    // Загружаем все темы до выбранной включительно
                    const requiredCount = themeIndex + 1;
                    
                    if (requiredCount > visibleThemesCount) {
                        setVisibleThemesCount(requiredCount);
                    }
                }
            }
        };

        // Проверяем hash при монтировании и изменении
        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);
        
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [allLongreadPosts, filteredThemesWithoutExam, examTheme, visibleThemesCount]);

    if (!outer || !hasAccess) return null;

    return (
        <>
        <InfiniteScrollWrapepr>
            <InfiniteScroll
                dataLength={visibleThemes.length + (visibleThemesCount > filteredThemesWithoutExam.length && examTheme ? 1 : 0)}
                next={loadMoreThemes}
                hasMore={hasMoreThemes ?? false}
                loader={
                    <FlexBox justify="center" align="center" width="100%" offsetTop={24} offsetBottom={24}>
                        <ProgressBar
                            text={t('text.loading')}
                            loading={false}
                            color={theme.progressbar?.color}
                        />
                    </FlexBox>
                }
                scrollThreshold={0.8}
            >
                {ThemesBlock}
            </InfiniteScroll>
        </InfiniteScrollWrapepr>
            {InfoList}
        </>
    )
}

export default memo(LMSLongreadList);